
const SAMPLES = {
  'Text': require('./aop_text_data'),
  'CSV': require('./aop_csv_templating'),
  'HTML': require('./aop_html_templating'),
  'Markdown': require('./aop_md_barcodes_tables_lists'),
  'Word': require('./aop_docx_data'),
  'Excel': require('./aop_xlsx_data'),
  'Powerpoint': require('./aop_pptx_data'),
  'Converter (Split)': require('./convert_split'),
  'PDF': require('./aop_pdf_data'),
};

export type Sample = [string, any];

export function getSamples(): Sample[] {
  return Object.keys(SAMPLES).map<Sample>(k => [k, SAMPLES[k]]);
}



// WEBPACK FOOTER //
// ./src/samples/index.ts